(function(){
  var s=document.currentScript;
  if(!s){ var sc=document.querySelectorAll('script[src*="ps-cta-stack"]'); s=sc[sc.length-1]; }

  /* ---- inject styles once ---- */
  if(!document.getElementById('ps-cta-style')){
    var st=document.createElement('style');
    st.id='ps-cta-style';
    st.textContent=[
      '[id^="AddToCart--"],#ps-ds-add-btn{padding-top:18px!important;padding-bottom:18px!important;font-size:14px!important;letter-spacing:.12em!important;text-transform:uppercase;}',
      '#ps-link-row{display:flex;flex-wrap:wrap;justify-content:center;align-items:center;gap:22px;row-gap:10px;margin:14px 0 4px;}',
      '#ps-link-row a{display:flex;align-items:center;gap:6px;font-size:11.5px;letter-spacing:.08em;text-transform:uppercase;color:#6b6a64;text-decoration:none;padding:6px 2px;min-height:32px;cursor:pointer;background:none;border:0;font-family:inherit;}',
      '#ps-link-row a:hover{color:#ab8c52;}',
      '#ps-link-row svg{width:15px;height:15px;flex-shrink:0;stroke:currentColor;}',
      '#ps-icon-row{margin-top:10px;border-top:1px solid #e4dfd2;border-bottom:1px solid #e4dfd2;display:grid;grid-template-columns:1fr 1fr;}',
      '#ps-icon-row .ps-cell{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;padding:20px 12px;min-height:56px;background:none;border:0;border-right:1px solid #e4dfd2;font-family:inherit;color:inherit;text-align:center;cursor:pointer;text-decoration:none;width:100%;}',
      '#ps-icon-row .ps-cell:last-child{border-right:0;}',
      '#ps-icon-row .ps-cell:hover{background:rgba(171,140,82,0.06);}',
      '#ps-icon-row .ps-cell svg{width:22px;height:22px;stroke:currentColor;}',
      '#ps-icon-row #ps-customise-tile svg{width:26px;height:26px;}',
      '#ps-icon-row .ps-cell span{font-size:11.5px;letter-spacing:.08em;text-transform:uppercase;line-height:1;}',
      '@keyframes ps-ring{0%,100%{transform:rotate(0)}10%{transform:rotate(-14deg)}20%{transform:rotate(12deg)}30%{transform:rotate(-10deg)}40%{transform:rotate(8deg)}50%{transform:rotate(-6deg)}60%{transform:rotate(4deg)}70%,100%{transform:rotate(0)}}',
      '#ps-icon-row .ps-phone:hover svg{animation:ps-ring .5s ease-in-out;transform-origin:50% 20%;}'
    ].join('');
    document.head.appendChild(st);
  }

  /* ---- compact link row: Add to Wishlist  |  Drop a Hint ---- */
  var linkRow=document.createElement('div');
  linkRow.id='ps-link-row';
  linkRow.innerHTML='<a id="ps-wishlist-link" role="button" tabindex="0"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 21s-7.5-4.6-10-9.1C.5 8.2 2.3 4.5 6 4c2-.3 3.7.7 6 3 2.3-2.3 4-3.3 6-3 3.7.5 5.5 4.2 4 7.9-2.5 4.5-10 9.1-10 9.1Z"/></svg>Add to Wishlist</a><a id="ps-hint-link" role="button" tabindex="0"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.6 10.5 15.4 6.5M8.6 13.5 15.4 17.5"/></svg>Drop a Hint</a>';

  /* ---- 2-column icon row: Customise | Call Us ---- */
  var row=document.createElement('div');
  row.id='ps-icon-row';
  row.innerHTML='<button type="button" class="ps-cell" id="ps-customise-tile" aria-label="Customise this design"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3.5c.8 3 2 4.4 4.8 5.2-2.8.8-4 2.2-4.8 5.2-.8-3-2-4.4-4.8-5.2 2.8-.8 4-2.2 4.8-5.2Z"/><path d="M18.5 14.5c.4 1.6 1.1 2.3 2.6 2.7-1.5.4-2.2 1.1-2.6 2.7-.4-1.6-1.1-2.3-2.6-2.7 1.5-.4 2.2-1.1 2.6-2.7Z"/></svg><span>Customise</span></button><a class="ps-cell ps-phone" href="tel:+441273846338" aria-label="Call us"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.3 1.8.6 2.7a2 2 0 0 1-.5 2.1L8 9.7a16 16 0 0 0 6 6l1.2-1.2a2 2 0 0 1 2.1-.5c.9.3 1.8.5 2.7.6a2 2 0 0 1 1.7 2Z"/></svg><span>Call Us</span></a>';

  if(s&&s.parentNode){ s.parentNode.insertBefore(row,s.nextSibling); s.parentNode.insertBefore(linkRow,row); }

  /* ---- hide native full-width Customise button + full-width Drop a Hint block (they're now tiles/links) ---- */
  function hideNativeCustomise(){
    var nats=[].slice.call(document.querySelectorAll('button')).filter(function(b){return b.textContent.trim().toLowerCase()==='customise' && !b.closest('#ps-icon-row');});
    nats.forEach(function(b){ b.style.display='none'; });
    return nats[0];
  }
  function hideNativeShare(){
    var sb=document.querySelector('.sharing-button');
    if(sb){ var blk=sb.closest('.product__block')||sb.closest('.share-holder')||sb; blk.style.display='none'; }
  }
  hideNativeCustomise(); hideNativeShare();
  setTimeout(function(){ hideNativeCustomise(); hideNativeShare(); },500);
  setTimeout(function(){ hideNativeCustomise(); hideNativeShare(); },1400);

  /* portal the customise dialog to <body> so its z-[6000] clears the sticky header.
     Done lazily (on first open), never at load, so it can't race Alpine init. */
  function portalPanel(){
    try{
      var panel=document.querySelector('[role="dialog"][aria-labelledby="customise-modal-title"]');
      if(panel && panel.parentElement!==document.body){ document.body.appendChild(panel); }
    }catch(e){}
  }

  /* ---- wire the tiles/links (resolve targets at click time) ---- */
  var tile=document.getElementById('ps-customise-tile');
  if(tile){ tile.addEventListener('click',function(){
    portalPanel();
    hideNativeCustomise();
    /* open the customise dialog directly via its window event (reliable);
       enrich with the product component's requestData() when available. */
    var detail={attributes:{},sku:''};
    try{
      var roots=document.querySelectorAll('[x-data]');
      for(var i=0;i<roots.length;i++){
        var st=roots[i]._x_dataStack;
        if(st&&st[0]&&typeof st[0].requestData==='function'){ detail=st[0].requestData(); break; }
      }
    }catch(e){}
    window.dispatchEvent(new CustomEvent('customise',{detail:detail,bubbles:true}));
  }); }
  function clickFirst(sel){ var e=document.querySelector(sel); if(e){ e.click(); } }
  var wl=document.getElementById('ps-wishlist-link');
  if(wl){ wl.addEventListener('click',function(){ clickFirst('button[aria-label="Add to Wishlist"], button[aria-label="Remove from Wishlist"]'); }); }
  var hint=document.getElementById('ps-hint-link');
  if(hint){ hint.addEventListener('click',function(){ clickFirst('.sharing-button'); }); }
})();
